if (!customElements.get('nosto-slider')) {
  class NostoSlider extends HTMLElement {
    constructor() {
      super();
      this.intervalLimit = 20;
      this.sectionId = '';
    }

    connectedCallback() {
      // Section ID used to assign custom Slick controls
      const nostoParent = this.closest('.nosto_element');
      this.sectionId = nostoParent?.getAttribute('data-section-id');

      // Get the template for the custom controls
      const controlsTemplate = document.getElementById(`nosto-placement-slider-controls--${this.sectionId}`);
      let controls;
      if (controlsTemplate) {
        // Clone the template content
        controls = controlsTemplate.content.cloneNode(true);
        // insert the cloned controls as the last child of the header
        nostoParent.querySelector('.nosto-placement__header')?.appendChild(controls);
      }

      this.interval = window.setInterval(() => {
        // If we've reached our maximum number of checks, clear the interval
        this.intervalLimit = this.intervalLimit - 1;
        if (this.intervalLimit <= 0) window.clearInterval(this.interval);

        // If Slick is not loaded, exit interval for this run
        if (!$().slick) return;

        // If Slick is loaded, initialize the slider
        this.initSlider(controls);
        // Once the slider is initialized, clear the interval
        window.clearInterval(this.interval);
      }, 500);
    }

    initSlider(controls) {
      this.style.display = 'flex';

      const showArrows = controls ? true : false;

      $(this).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: showArrows,
        prevArrow: $(`#${this.sectionId} .controls__arrow__prev`),
        nextArrow: $(`#${this.sectionId} .controls__arrow__next`),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: false
            }
          }
        ]
      });
    }

    disconnectedCallback() {
      console.log('nosto-slider disconnected');
    }
  }

  customElements.define('nosto-slider', NostoSlider);
}

if (!customElements.get('nosto-card')) {
  class NostoCard extends HTMLElement {
    constructor() {
      super();
      this.sectionId = '';
    }

    connectedCallback() {
      // Section ID passed to card-product snippet via query string
      const nostoParent = this.closest('.nosto_element');
      this.sectionId = nostoParent?.getAttribute('data-section-id');

      // Slick re-triggers connectedCallback; if we've already created the card, don't do it again
      if (this.querySelector('.card-wrapper')) return;

      const productHandle = this.getAttribute('data-product-handle');

      if (productHandle) {
        // Fetch the rendered card HTML from our endpoint using Shopify's view rendering
        fetch(`/products/${productHandle}?view=nosto-card&sectionId=${this.sectionId}`)
          .then(response => response.text())
          .then(html => {
            // Extract just the card content from the response
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const cardContent = doc.querySelector('.card-wrapper');

            // Clear existing content
            while (this.firstChild) {
              this.removeChild(this.firstChild);
            }

            // Append the card content if it exists, otherwise remove the element
            if (cardContent) {
              // Add the styles to the first card
              const isFirstCard = this.hasAttribute('data-first-card') || this.parentNode?.querySelectorAll('nosto-card:not(:empty)').length === 0;
              if (isFirstCard) {
                const styleTags = doc.querySelectorAll('link[rel="stylesheet"]');
                styleTags.forEach(styleTag => {
                  this.appendChild(styleTag.cloneNode(true));
                });
              }
              this.appendChild(cardContent.cloneNode(true));

              // swym wishlist: initialize once card content is appended
              this.refreshSwym();

              // swym wishlist: refresh wishlist product when swatch is clicked
              const cardElement = this.querySelector('.card');
              cardElement.addEventListener('swym:refresh', () => {
                this.refreshSwym();
              });
            } else {
              this.remove();
            }
          })
          .catch(error => {
            console.error('Error fetching product card:', error);
            this.remove();
          });
      }
    }

    refreshSwym() {
      if(window._swat) {
        window._swat.initializeActionButtons(`#${this.sectionId}`);
      }
    }
  }

  customElements.define('nosto-card', NostoCard);
}